import React, { FC } from 'react'
import { Popover, PopoverPosition, Icon } from '@blueprintjs/core'
import style from './style.scss'


interface Props {
    info: string
    customStyle?: any
    icon?: any
}

export const InfoTip: FC<Props> = props => {
    return (
        <span className={style.popover} style={props.customStyle}>
            <Popover
                position={PopoverPosition.TOP}
                interactionKind={'hover'}
                content={<div style={{ width: '300px', padding: '10px' }}>{props.info}</div>}
            >
                {props.icon ? props.icon : <Icon icon="info-sign" iconSize={14} />}
            </Popover>
        </span>
    )
}
